'use client';
/**
 * HiddenLinkSweeper — removes cross-links into hidden product areas from every
 * page (dashboard cards, "next step" buttons, feature tour…) so a hidden
 * feature is not advertised anywhere. Anything that still gets through lands
 * on /feature-hidden via the middleware. Single switch: lib/hidden_features.js.
 */
import { useEffect } from 'react';
import { isHiddenHref } from '@/lib/hidden_features';

export default function HiddenLinkSweeper() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    let timer = null;
    const sweep = () => {
      timer = null;
      const anchors = document.querySelectorAll('a[href^="/"]:not([data-ol-hidden])');
      for (const a of anchors) {
        let href = '';
        try { href = a.getAttribute('href') || ''; } catch { continue; }
        if (!isHiddenHref(href)) continue;
        a.setAttribute('data-ol-hidden', '1');
        // Hide the smallest card-like wrapper when the link is its only content, else just the link.
        const card = a.closest('li, [data-card], .card, article');
        const target = card && card.querySelectorAll('a[href^="/"]').length === 1 && card.textContent.trim().length < 400 ? card : a;
        target.style.display = 'none';
      }
    };
    const schedule = () => { if (!timer) timer = setTimeout(sweep, 60); };
    sweep();
    const mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { mo.disconnect(); if (timer) clearTimeout(timer); };
  }, []);
  return null;
}
